'use strict';

const angular = require('angular');

import { IPayment, IBasket } from '../../interfaces';

export class adminBasketPaymentComponent{
  $http: ng.IHttpService;

  payment: IPayment;
  basket: IBasket;
  
  submitted = false;
  newPayment: boolean = true;
  sendMail: boolean = false;

  /*ngInjector*/
  constructor($http) {
    this.$http = $http;
  }

  $onInit() {
    let resolve = (this as any).resolve;

    if (_.has(resolve, 'basket') && resolve.basket !== null) {
      this.basket = resolve.basket;
      
      if (_.has(resolve, 'payment') && resolve.payment !== null) {
        // Edit an existing payment
        for (let pay of this.basket.payments) {
          if (pay._id == resolve.payment._id) {
            this.payment = pay;
          }
        }
        
        this.newPayment = false;

      } else {
        // Create one new payment
        this.payment = { _id: null, date: (new Date()).toString(), amount: 0 };
        this.newPayment = true;
      }

    } else {
      this.cancel();
    }
  }

  save(form) {
    this.submitted = true;

    if (form.$valid) {
      let candidate = _.cloneDeep(this.basket);
      delete (candidate as any).$totalExtras;
      delete (candidate as any).$total;
      delete (candidate as any).$debt;
      
      //Parse extras to data
      this.parseExtraToData(candidate);

      if (this.newPayment) {
        //Adding the new payment
        candidate.payments.push(this.payment);
      }
      
      this.$http.put("/api/baskets/payment/"+this.basket._id, candidate, { params: {sendMail: this.sendMail} })
        .then(res => {
          this.basket = res.data as IBasket;
          this.ok();
        });;
    }
  }

  /**
   * Parsing basket's extras from model to data to save on database
   * @param basket 
   */
  parseExtraToData(basket) {
    let extrasParsing = [];

    _.each(basket.extras, extra => {
      extrasParsing.push({
        extra: extra.extra._id,
        quantity: extra.quantity
      });
    });
  }

  ok() {
    (this as any).close({$value: this.basket});
  };

  cancel() {
    (this as any).dismiss({$value: 'cancel'});
  };

}

export default angular.module('terrappApp.adminBaskets')
  .component('adminBasketPayment', {
    template: require('./adminBasketPayment.html'),
    controller: adminBasketPaymentComponent,
    controllerAs: '$ctrl',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
    },
  }).name;


// WEBPACK FOOTER //
// ./client/app/admin/adminBaskets/adminBasketPayment.component.ts